export default ({ dropdown }) => {
  const { checkbox } = dropdown;
  return {
    root: {
      '&$root$root': {
        background: 'transparent',
        border: 0,
        color: dropdown.text,
        cursor: 'pointer',
        fontSize: dropdown.fontSize,
        position: 'relative',
        textAlign: 'left',
        width: '100%',
        display: 'block',
        wordBreak: 'break-word',
        fontFamily: dropdown.fontFamily,
        textTransform: 'none',
        lineHeight: '32px',
        paddingRight: 32,
        '& p': {
          fontSize: dropdown.fontSize,
          marginRight: 3,
          margin: 0,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        '& label': {
          margin: 0,
          fontSize: dropdown.fontSize,
          fontWeight: 'inherit',
          textTransform: 'none',
          height: 32,
          display: 'inline-flex',
          width: '100%',
          alignItems: 'center',
        },
        '&:hover, &:focus': {
          background: dropdown.hoverBg,
        },
        '&:focus': {
          outlineColor: dropdown.focusColor,
        },
      },
    },
    singleOptionWrapper: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 2,
      background: dropdown.background,
      '&$dark': {
        background: dropdown.dark.background,
      },
    },
    depth1: { paddingLeft: 16 },
    depth2: { paddingLeft: 32 },
    depth3: { paddingLeft: 48 },
    depth4: { paddingLeft: 64 },
    depth5: { paddingLeft: 80 },
    depth6: { paddingLeft: 96 },
    disabled: {
      opacity: 0.5,
    },
    highlight: {
      background: dropdown.highlightBg,
    },
    selected: {
      background: dropdown.hoverBg,
    },
    categoryButton: {
      border: 0,
      background: 'transparent',
      paddingRight: 6,
      paddingLeft: 0,
      width: 32,
      height: 32,
      position: 'absolute',
      right: 0,
      bottom: 4,
      '&:hover': {
        cursor: 'pointer',
      },
      '&:disabled': {
        cursor: 'not-allowed',
        color: dropdown.disabledText,
      },
      '&:focus': {
        outlineColor: dropdown.focusColor,
      },
    },
    icon: {
      '& svg': {
        height: 12,
        fill: dropdown.iconFill,
      },
      '&$dark svg': {
        fill: dropdown.dark.iconFill,
      },
    },
    checkboxRoot: {
      position: 'relative',
      cursor: 'pointer',
      height: 18,
      lineHeight: '18px',
      padding: [0, 0, 0, 26],
      marginBottom: 15,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'inline-block!important',
      textOverflow: 'ellipsis',
      '& input': {
        width: 16,
        height: 16,
        margin: 0,
        zIndex: 1,
        left: 0,
        position: 'absolute',
        top: '50%',
        marginTop: -9,
        opacity: 0,
      },
      '& p': {
        margin: 0,
      },
      '& input:focus + $checkboxIcon': {
        outline: `${checkbox.selectedColor} solid 1px`,
        boxShadow: `0 0px 8px ${checkbox.shadowColor}`,
      },
    },
    checkboxLabelText: {
      position: 'relative',
      top: 7,
      left: 15,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'inline-block',
      textOverflow: 'ellipsis',
      width: '98%',
    },
    checkboxDisabled: {
      opacity: 0.5,
    },
    checkboxSelected: {},
    checkboxIcon: {
      background: 'transparent',
      borderColor: checkbox.borderColor,
      borderRadius: 2,
      borderStyle: 'solid',
      borderWidth: 1,
      display: 'inline-block',
      height: 16,
      left: 15,
      marginTop: -9,
      position: 'absolute',
      top: '50%',
      width: 16,
      '& svg': {
        fill: checkbox.checkColor,
        width: 8,
        height: 8,
        position: 'absolute',
        left: 3,
        top: 3,
      },
      '&$checkboxSelected': {
        background: checkbox.selectedColor,
        borderColor: checkbox.selectedColor,
      },
    },
    dark: {
      '&$root$root, &$root$root $checkboxRoot': {
        background: dropdown.dark.background,
        color: dropdown.dark.text,
        '&:hover, &:focus': {
          background: dropdown.dark.hoverBg,
        },
        '&:focus': {
          outlineColor: dropdown.dark.darkFocusColor,
        },
      },
      '&$highlight': {
        background: dropdown.dark.highlightBg,
      },
      '&$selected': {
        background: dropdown.dark.hoverBg,
      },
      '& $categoryButton': {
        '&:disabled': {
          color: dropdown.dark.disabledText,
        },
        '&:focus': {
          outlineColor: dropdown.dark.darkFocusColor,
        },
      },
      '& $checkboxIcon': {
        borderColor: checkbox.dark.borderColor,
      },
      '& $checkboxSelected': {
        background: checkbox.dark.selectedColor,
        borderColor: checkbox.dark.selectedColor,
      },
      '& svg': {
        fill: checkbox.dark.checkColor,
      },
    },
  };
};
